export class MobileConstants{
    static CALL_CONNECTED_TEXT: string = "Video Call In Progress";
    static CALL_DISCONNECTED_TEXT: string = "You have left the call";
    static CALL_CONNECTED_ACTION_BUTTON_TEXT: string = "EXPAND";
    static CALL_DISCONNECTED_ACTION_BUTTON_TEXT: string = "REJOIN";
    
    static CALL_DISCONNECTED_EVENT = "CALL_DISCONNECTED"
    static CALL_DISCONNECTED = new Event(MobileConstants.CALL_DISCONNECTED_EVENT);
    static CALL_CONNECTED_EVENT = "CALL_CONNECTED"
    static CALL_CONNECTED = new Event(MobileConstants.CALL_CONNECTED_EVENT);
}